import type { SymbolWinEffect, SymbolWinAnimationRequest } from "./SymbolWinEffect";

/**
 * Runs SEVERAL `SymbolWinEffect`s for every winning symbol — `play()` fans out to all,
 * `stopAll()` stops all. Effects that shouldn't apply to a given symbol self-skip in `play()`.
 */
export class CompositeSymbolWinEffect implements SymbolWinEffect {
  private readonly effects: readonly SymbolWinEffect[];

  public constructor(effects: readonly SymbolWinEffect[]) {
    this.effects = effects;
  }

  public play(request: SymbolWinAnimationRequest): void {
    for (const effect of this.effects) effect.play(request);
  }

  public stopAll(opts?: { revert?: boolean }): void {
    for (const effect of this.effects) effect.stopAll(opts);
  }

  public getPlaySeconds(symbolId: string): number {
    let max = 0;
    for (const effect of this.effects) {
      const seconds = effect.getPlaySeconds?.(symbolId) ?? 0;
      if (seconds > max) max = seconds;
    }
    return max;
  }
}
